import { render } from "./Nav.vue?vue&type=template&id=50dd5f2d"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=50dd5f2d&lang=css"
script.render = render

export default script